var isArray = Array.isArray;
var toClassName = function (val) {
    if (typeof val === 'string')
        return val;
    if (typeof val !== 'object')
        return '';
    var str = '';
    var tmp;
    if (isArray(val)) {
        var i = 0;
        while (i < val.length) {
            tmp = toClassName(val[i++]);
            if (tmp)
                str += (str && ' ') + tmp;
        }
    }
    else {
        for (tmp in val) {
            if (val[tmp] && tmp) {
                str += (str && ' ') + tmp;
            }
        }
    }
    return str;
};
export function cnb() {
    var i = 0;
    var tmp;
    var str = '';
    while (i < arguments.length) {
        tmp = toClassName(arguments[i++]);
        if (tmp)
            str += (str && ' ') + tmp;
    }
    return str;
}
